module.exports = __webpack_public_path__ + "static/media/boro.2f70c241.png";